import { useCsAttribute } from "./useCsAttribute";
import { useCsValue } from "./useCsValue";
import { useLocalCheckboxValues } from "./useLocalCheckboxValues";
import { useLocalSelectValue } from "./useLocalSelectValue";
/**
 * Determines if an option is selected
 *
 * - works for single and valued attributes
 * - does not work for editable attributes
 *
 * Requires
 * - {@linkcode CsAttributeController}
 * - {@linkcode CsValueController}
 *
 * @category Hook
 * @category CsValue
 * @returns
 */
export function useLocalOptionSelected() {
    const attribute = useCsAttribute();
    const value = useCsValue();
    // we need both because of hooks
    const multiSelectValues = useLocalCheckboxValues();
    const selectValue = useLocalSelectValue();
    if (attribute.isMultiValued) {
        return multiSelectValues[value.value] === true;
    }
    else {
        return selectValue === value.value;
    }
}
//# sourceMappingURL=useLocalOptionSelected.js.map